$(document).on("turbolinks:load", () => {
    $('#nav-icon').click(function(){
        $(this).toggleClass('open');
    });
})